import React, { useState, useEffect } from "react";
import api from '../api';
import * as XLSX from "xlsx";
import '../styles/ofertas.scss';

const OfertasComponent = () => {
    const [modificacoes, setModificacoes] = useState([]);
    const [modificacoesRealizadas, setModificacoesRealizadas] = useState([]);

    useEffect(() => {
        const fetchModificacoes = async () => {
            try {
                const response = await api.get('/log-ofertas');
                const lastTwoModificacoes = response.data.slice(-2);
                setModificacoes(lastTwoModificacoes);
                getModificacoesRealizadas(lastTwoModificacoes);
            } catch (error) {
                console.error('Erro ao buscar modificações:', error);
            }
        };

        fetchModificacoes();
    }, []);

    const getModificacoesRealizadas = (modificacoes) => {
        if (modificacoes.length < 2) return;

        const [sobrescricao, atualizacao] = modificacoes;
        const modificacoesFeitas = [];

        for (const key in atualizacao) {
            if (atualizacao[key] !== sobrescricao[key]) {
                modificacoesFeitas.push({
                    campo: key,
                    valorAnterior: sobrescricao[key],
                    valorAtual: atualizacao[key],
                });
            }
        }

        setModificacoesRealizadas(modificacoesFeitas);
    };

    const downloadExcel = async () => {
        try {
            const response = await api.get('/log-ofertas'); // Usa a instância do Axios com o token já configurado
            const data = response.data; // Obtém os dados
    
            // Converte os dados para um formato Excel
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Ofertas');
    
            // Formata a data e hora atual
            const now = new Date();
            const formattedDate = now.toLocaleString('pt-BR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }).replace(/\//g, '-').replace(',', ''); // Substitui / por - e remove a vírgula
    
            const fileName = `Ofertas—${formattedDate}.xlsx`; // Define o nome do arquivo
    
            // Faz o download do arquivo Excel
            XLSX.writeFile(workbook, fileName);
        } catch (error) {
            alert('Erro ao baixar as Ofertas: ' + error.message);
        }
    };
    
    

    return (
        <div className>
            <h1>Ofertas</h1>
            <button onClick={downloadExcel}>Download Excel</button>
            <table>
                <thead>
                    <tr>
                        <th>USUARIO</th>
                        <th>AÇÃO</th>
                        <th>ATIVO</th>
                        <th>CODCURSO</th>
                        <th>CRIADO POR</th>
                        <th>CRIADO EM</th>
                        <th>ATUALIZADO POR</th>
                        <th>ATUALIZADO EM</th>
                    </tr>
                </thead>
                <tbody>
                    {modificacoes.map((modificacao, index) => (
                        <tr key={index}>
                            <td>{modificacao['USUARIO']}</td>
                            <td>{modificacao['AÇÃO']}</td>
                            <td>{modificacao['ATIVO']}</td>
                            <td>{modificacao['CODCURSO']}</td>
                            <td>{modificacao['CRIADO POR']}</td>
                            <td>{modificacao['CRIADO EM']}</td>
                            <td>{modificacao['ATUALIZADO POR']}</td>
                            <td>{modificacao['ATUALIZADO EM']}</td>
                        </tr>
                    ))}
                </tbody>
                <br />
                <thead>
                    <tr>
                        <th>MODIFICAÇÕES REALIZADAS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {modificacoesRealizadas.map((modificacao, index) => (
                            <td key={index}>
                                <strong>{modificacao.campo}: </strong>
                                {modificacao.valorAnterior} → {modificacao.valorAtual}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default OfertasComponent;
